import { Toast } from 'bootstrap';
import { v4 as uuidv4 } from 'uuid';
import tplToast from '../templates/toast.pug';

/**
 * Display Bootstrap toast message
 * 
 * @param {string} message - Message text
 * @param {object} options - Optional settings
 * @param {string} [options.theme=danger] - Toast color theme (danger | success)
 * @param {boolean} [options.animation=true] - Toast fade animation
 * @param {boolean} [options.autohide=true] - Toast auto-hide
 * @param {boolean} [options.delay=5000] - Toast auto-hide delay in milliseconds
 * 
 * @returns {void}
 */
export const addToast = (message, options = {}) => {
  const _defaults = {
    theme: 'danger',
    animation: true,
    autohide: true,
    delay: 5000,
  };
  const opts = { ..._defaults, ...options };
  
  // toast container
  let containerEl = document.querySelector('.toast-container');
  if (!containerEl) {
    document.body.insertAdjacentHTML('beforeend', `<div class="toast-container position-fixed zi-10 top-0 end-0 p-3 pt-fixed-112"></div>`);
    containerEl = document.querySelector('.toast-container');
  }

  // add toast element
  const toastId = uuidv4();
  const toastHtml = tplToast({
    id: toastId,
    theme: (opts.theme) ? `bg-${opts.theme}` : null,
    message,
    i18n: {
      btn_close_label: Settings.general.i18n.btn_close,
    },
  });
  containerEl.insertAdjacentHTML('afterbegin', toastHtml);
  const toastEl = document.getElementById(toastId);

  const toast = new Toast(toastEl, {
    animation: opts.animation,
    autohide: opts.autohide,
    delay: opts.delay,
  });
  toast.show();
  toastEl.addEventListener('hidden.bs.toast', () => {
    toast.dispose();
    containerEl.removeChild(toastEl);
  });
};
